import PropTypes from 'prop-types';
import React from 'react';
import epicTracking from 'epic-tracking';
import {withLocalization} from 'epic-localization/src/context/LocalizationContext';

const CTADownload = ({link, image, country, getMessage}) => {
    
    const downloadTracking = React.useCallback(() => {
        epicTracking.trackEvent('Interaction', {
            interactionType: 'click',
            eventCategory: `Download_IOS_${country}`,
            eventAction: 'download'
        });
    }, [country]);
    
    return (
        <a className="download-button" onClick={downloadTracking} href={link}>
            <img src={image} className="img-responsive" alt={getMessage('epic.common.appStore')} />
        </a>
    );
};
CTADownload.propTypes = {
    link: PropTypes.string,
    image: PropTypes.string,
    country: PropTypes.string,
    getMessage: PropTypes.func
}

export default withLocalization(CTADownload);
